'use strict';

class CXPointsArraySimple {
    constructor () {
        this._pointsArray = new Array();
        this._firstPoint = 0;
        this._maxSize = 0;
    }

    /**
     * Getter points array
     *
     * @memberof CXPointsArraySimple return points arary
     */
    get pointsArray () {
        return this._pointsArray;
    }

    /**
     * Setter points array
     *
     * @memberof CXPointsArraySimple array of points
     */
    set pointsArray (o) {
        this._maxSize = o.length;
        this._pointsArray = o;
    }

    /**
     * Add new points to array
     * @param {*} x x coordinate
     * @param {*} y y coordinate
     * @param {*} level level
     * @param {*} isSurounded is the pixel surrounded
     */
    addPoint (x = x, y = y, level = level, isSurounded = isSurounded) {
        this._pointsArray.push({
            x: x,
            y: y,
            l: level,
            s: isSurounded
        });
        this._maxSize += 1;
    }

    /**
     * Remove first point in array
     */
    removeFirstPoint () {
        this._firstPoint += 1;
    }

    /**
     * Return first point in array
     */
    firstObject () {
        return this._pointsArray[this._firstPoint];
    }

    /**
     * Points array length
     */
    count () {
        return this._maxSize - this._firstPoint;
    }
}
export default CXPointsArraySimple;
